import React from "react";
import LiveMarket from "./LiveMarket";

export default function Markets() {
    return <LiveMarket />;
}